import { render, staticRenderFns } from "./DetailsBoughtWon.vue?vue&type=template&id=d6a42d04"
import script from "./DetailsBoughtWon.vue?vue&type=script&lang=js"
export * from "./DetailsBoughtWon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports